
// import React, { useState, useEffect } from 'react';
// import { Search, FileText, Eye, Download, Loader, AlertCircle, X } from 'lucide-react';
// import styles from './ConsentManager.module.css';
// import { getConsents, getConsentsFiles, updateConsent, getConsentsDownload } from '../../Config/api';
// import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';

// const ConsentManager = ({ userRole = 'CRO', currentPIName = 'Mahesh' }) => {
//     const [searchQuery, setSearchQuery] = useState('');
//     const [submissions, setSubmissions] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [userId, setUserId] = useState(null);

//     const [showPreviewModal, setShowPreviewModal] = useState(false);
//     const [previewFile, setPreviewFile] = useState(null);
//     const [previewLoading, setPreviewLoading] = useState(false);
//     const [previewError, setPreviewError] = useState(null);

//     const [showRejectModal, setShowRejectModal] = useState(false);
//     const [showReasonModal, setShowReasonModal] = useState(false);
//     const [selectedConsentId, setSelectedConsentId] = useState(null);
//     const [rejectReason, setRejectReason] = useState('');
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [downloadingId, setDownloadingId] = useState(null);

//     const [modal, setModal] = useState({
//         show: false,
//         title: '',
//         message: '',
//         type: 'info',
//         confirmText: 'OK',
//         cancelText: null,
//         onConfirm: null,
//         onCancel: null
//     });

//     const showModal = (config) => {
//         setModal({
//             show: true,
//             title: config.title || '',
//             message: config.message || '',
//             type: config.type || 'info',
//             confirmText: config.confirmText || 'OK',
//             cancelText: config.cancelText || null,
//             onConfirm: config.onConfirm || closeModal,
//             onCancel: config.onCancel || closeModal
//         });
//     };

//     const closeModal = () => {
//         setModal({
//             show: false,
//             title: '',
//             message: '',
//             type: 'info',
//             confirmText: 'OK',
//             cancelText: null,
//             onConfirm: null,
//             onCancel: null
//         });
//     };

//     useEffect(() => {
//         fetchSubmissions();
//     }, []);

//     const fetchSubmissions = async () => {
//         setIsLoading(true);
//         setError(null);

//         try {
//             const userDetails = JSON.parse(localStorage.getItem('user')) || {};
//             const role = userDetails.role || userRole;
//             const currentUserId = userDetails.userId;

//             setUserId(currentUserId);

//             const requestData = {
//                 userId: currentUserId,
//                 role: role
//             };

//             const response = await getConsents(requestData);

//             let consentsList = [];

//             if (Array.isArray(response.data)) {
//                 consentsList = response.data;
//             } else if (response.data && typeof response.data === 'object') {
//                 consentsList = [response.data];
//             } else if (Array.isArray(response)) {
//                 consentsList = response;
//             } else {
//                 consentsList = [];
//             }

//             const mappedSubmissions = consentsList.map(consent => {
//                 const documents = [];

//                 if (consent.uploaded_docs) {
//                     Object.entries(consent.uploaded_docs).forEach(([docType, docInfo]) => {
//                         if (docInfo && docInfo.filename && docInfo.originalName) {
//                             documents.push({
//                                 name: docInfo.originalName,
//                                 filename: docInfo.filename,
//                                 type: docType
//                             });
//                         }
//                     });
//                 }

//                 let status = 'PENDING';
//                 const consentStatus = consent.consent_status?.toLowerCase();

//                 if (consentStatus === 'a' || consentStatus === 'approved') {
//                     status = 'APPROVED';
//                 } else if (consentStatus === 'r' || consentStatus === 'rejected') {
//                     status = 'REJECTED';
//                 } else if (consentStatus === 'p' || consentStatus === 'pending') {
//                     status = 'PENDING';
//                 }

//                 const mappedConsent = {
//                     id: consent.id,
//                     piName: consent.full_name || 'N/A',
//                     protocolNumber: consent.study_number || 'N/A',
//                     studyName: consent.study_title || 'N/A',
//                     siteDetails: {
//                         code: consent.site_code || 'N/A',
//                         name: consent.site_name || 'N/A'
//                     },
//                     maxSubjects: consent.max_subjects || 0,
//                     submittedOn: consent.created_at || new Date().toISOString(),
//                     status: status,
//                     documents: documents,
//                     reason: consent.reason || null
//                 };

//                 return mappedConsent;
//             });

//             setSubmissions(mappedSubmissions);

//         } catch (error) {
//             setError(error.response?.data?.message || 'Failed to load submissions. Please try again.');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const getFilteredSubmissions = () => {
//         let filtered = [...submissions];

//         if (userRole === 'PI') {
//             const userDetails = JSON.parse(localStorage.getItem('user')) || {};
//             const currentUserName = userDetails.fullName || currentPIName;

//             filtered = submissions.filter(sub => {
//                 return sub.piName === currentUserName;
//             });
//         }

//         if (searchQuery) {
//             filtered = filtered.filter(sub =>
//                 sub.piName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 sub.protocolNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 sub.siteDetails.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 sub.siteDetails.name.toLowerCase().includes(searchQuery.toLowerCase())
//             );
//         }

//         return filtered;
//     };

//     const handleDownloadConsentAgreement = async (consentId) => {
//     try {
//         setDownloadingId(consentId);

//         const payload = {
//             consent_id: consentId,
//             type: 'pdf'
//         };

//         const response = await getConsentsDownload(payload);

//         console.log('Download response:', response);

//         let pdfData = null;

//         if (response?.data) {
//             pdfData = response.data;
//         } else if (response) {
//             pdfData = response;
//         }

//         if (pdfData) {
//             const blob = new Blob([pdfData], { type: 'application/pdf' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.download = `consent_agreement_${consentId}.pdf`;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } else {
//             showModal({
//                 title: 'Error',
//                 message: 'Failed to download consent agreement. No data received.',
//                 type: 'error',
//                 confirmText: 'OK'
//             });
//         }

//     } catch (error) {
//         console.error('Download error:', error);
//         showModal({
//             title: 'Error',
//             message: error.response?.data?.message || 'Failed to download consent agreement. Please try again.',
//             type: 'error',
//             confirmText: 'OK'
//         });
//     } finally {
//         setDownloadingId(null);
//     }
// };

//     const handleApprove = async (id) => {
//         try {
//             setIsSubmitting(true);

//             const data = {
//                 consentId: id,
//                 status: 'a',
//                 reason: ''
//             };

//             const response = await updateConsent(data);

//             if (response.success || response.data?.success || response.data?.message === 'Consent status updated' || response.message === 'Consent status updated') {
//                 showModal({
//                     title: 'Success',
//                     message: 'Consent approved successfully!',
//                     type: 'success',
//                     confirmText: 'OK',
//                     onConfirm: async () => {
//                         closeModal();
//                         await fetchSubmissions();
//                     }
//                 });
//             } else {
//                 showModal({
//                     title: 'Success',
//                     message: 'Consent approved successfully!',
//                     type: 'success',
//                     confirmText: 'OK',
//                     onConfirm: async () => {
//                         closeModal();
//                         await fetchSubmissions();
//                     }
//                 });
//             }

//         } catch (error) {
//             if (error.message === 'Consent status updated' || error.response?.data?.message === 'Consent status updated') {
//                 showModal({
//                     title: 'Success',
//                     message: 'Consent approved successfully!',
//                     type: 'success',
//                     confirmText: 'OK',
//                     onConfirm: async () => {
//                         closeModal();
//                         await fetchSubmissions();
//                     }
//                 });
//             } else {
//                 showModal({
//                     title: 'Error',
//                     message: error.response?.data?.message || error.message || 'Failed to approve consent. Please try again.',
//                     type: 'error',
//                     confirmText: 'OK'
//                 });
//             }
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const handleRejectClick = (id) => {
//         setSelectedConsentId(id);
//         setShowRejectModal(true);
//     };

//     const handleRejectConfirm = () => {
//         setShowRejectModal(false);
//         setShowReasonModal(true);
//     };

//     const handleRejectCancel = () => {
//         setShowRejectModal(false);
//         setSelectedConsentId(null);
//     };

//     const handleReasonSubmit = async () => {
//         if (!rejectReason.trim()) {
//             showModal({
//                 title: 'Validation Error',
//                 message: 'Please provide a reason for rejection',
//                 type: 'warning',
//                 confirmText: 'OK'
//             });
//             return;
//         }

//         try {
//             setIsSubmitting(true);

//             const data = {
//                 consentId: selectedConsentId,
//                 userId: userId,
//                 status: 'r',
//                 reason: rejectReason
//             };

//             const response = await updateConsent(data);

//             if (response.success || response.data?.success || response.data?.message === 'Consent status updated' || response.message === 'Consent status updated') {
//                 showModal({
//                     title: 'Success',
//                     message: 'Consent rejected successfully!',
//                     type: 'success',
//                     confirmText: 'OK',
//                     onConfirm: async () => {
//                         closeModal();
//                         setShowReasonModal(false);
//                         setRejectReason('');
//                         setSelectedConsentId(null);
//                         await fetchSubmissions();
//                     }
//                 });
//             } else {
//                 showModal({
//                     title: 'Success',
//                     message: 'Consent rejected successfully!',
//                     type: 'success',
//                     confirmText: 'OK',
//                     onConfirm: async () => {
//                         closeModal();
//                         setShowReasonModal(false);
//                         setRejectReason('');
//                         setSelectedConsentId(null);
//                         await fetchSubmissions();
//                     }
//                 });
//             }

//         } catch (error) {
//             if (error.message === 'Consent status updated' || error.response?.data?.message === 'Consent status updated') {
//                 showModal({
//                     title: 'Success',
//                     message: 'Consent rejected successfully!',
//                     type: 'success',
//                     confirmText: 'OK',
//                     onConfirm: async () => {
//                         closeModal();
//                         setShowReasonModal(false);
//                         setRejectReason('');
//                         setSelectedConsentId(null);
//                         await fetchSubmissions();
//                     }
//                 });
//             } else {
//                 showModal({
//                     title: 'Error',
//                     message: error.response?.data?.message || error.message || 'Failed to reject consent. Please try again.',
//                     type: 'error',
//                     confirmText: 'OK'
//                 });
//             }
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const handleReasonCancel = () => {
//         setShowReasonModal(false);
//         setRejectReason('');
//         setSelectedConsentId(null);
//     };

//     const handleViewDocument = async (filename, documentName) => {
//         setShowPreviewModal(true);
//         setPreviewLoading(true);
//         setPreviewError(null);
//         setPreviewFile(null);

//         try {
//             const response = await getConsentsFiles({ files: [filename] });

//             let fileUrl = null;
//             let fileType = null;

//             if (response.files[0].filename) {
//                 fileUrl = response.files[0].url;
//                 fileType = response.files[0].type || response.files[0].mimeType;
//             } else if (response.files[0]?.file) {
//                 fileUrl = response.files[0].file;
//             } else if (response.url) {
//                 fileUrl = response.url;
//             } else if (typeof response.data === 'string') {
//                 fileUrl = response.data;
//             }

//             if (fileUrl && fileUrl.startsWith('data:')) {
//                 setPreviewFile({
//                     url: fileUrl,
//                     name: documentName,
//                     type: fileType || getFileTypeFromName(documentName)
//                 });
//             } else if (fileUrl) {
//                 setPreviewFile({
//                     url: fileUrl,
//                     name: documentName,
//                     type: fileType || getFileTypeFromName(documentName)
//                 });
//             } else {
//                 throw new Error('File URL not found in response');
//             }

//         } catch (error) {
//             setPreviewError(error.response?.data?.message || 'Failed to load file preview. Please try again.');
//         } finally {
//             setPreviewLoading(false);
//         }
//     };

//     const getFileTypeFromName = (filename) => {
//         const extension = filename.split('.').pop().toLowerCase();
//         const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
//         const pdfExtensions = ['pdf'];

//         if (imageExtensions.includes(extension)) {
//             return 'image';
//         } else if (pdfExtensions.includes(extension)) {
//             return 'pdf';
//         }
//         return 'unknown';
//     };

//     const handleClosePreview = () => {
//         setShowPreviewModal(false);
//         setPreviewFile(null);
//         setPreviewError(null);
//     };

//     const handleDownloadDocument = (filename, documentName) => {
//         if (filename) {
//             const fileUrl = `${process.env.REACT_APP_API_BASE_URL || ''}/files/${filename}`;
//             const link = document.createElement('a');
//             link.href = fileUrl;
//             link.download = documentName;
//             link.target = '_blank';
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//         } else {
//             showModal({
//                 title: 'Document Error',
//                 message: 'Document not available',
//                 type: 'error',
//                 confirmText: 'OK'
//             });
//         }
//     };

//     const getStatusBadgeClass = (status) => {
//         switch (status) {
//             case 'PENDING':
//                 return styles.statusPending;
//             case 'APPROVED':
//                 return styles.statusApproved;
//             case 'REJECTED':
//                 return styles.statusRejected;
//             default:
//                 return styles.statusPending;
//         }
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return '';
//         const { formatDateTimeWithSeconds } = require('../../utils/dateFormatter');
//         return formatDateTimeWithSeconds(dateString);
//     };

//     if (isLoading) {
//         return (
//             <div className={styles.container}>
//                 <div className={styles.loadingWrapper}>
//                     <Loader className={`${styles.loadingIcon} ${styles.spinning}`} />
//                     <p className={styles.loadingText}>Loading submissions...</p>
//                 </div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className={styles.container}>
//                 <div className={styles.errorWrapper}>
//                     <AlertCircle className={styles.errorIconLarge} />
//                     <h2 className={styles.errorTitle}>Failed to Load Submissions</h2>
//                     <p className={styles.errorMessage}>{error}</p>
//                     <button onClick={fetchSubmissions} className={styles.retryButton}>
//                         Retry
//                     </button>
//                 </div>
//             </div>
//         );
//     }

//     const filteredSubmissions = getFilteredSubmissions();

//     return (
//         <div className={styles.container}>
//             <ConfirmationModal
//                 show={modal.show}
//                 title={modal.title}
//                 message={modal.message}
//                 type={modal.type}
//                 confirmText={modal.confirmText}
//                 cancelText={modal.cancelText}
//                 onConfirm={modal.onConfirm}
//                 onCancel={modal.onCancel}
//             />

//             <div className={styles.header}>
//                 <div>
//                     <h1 className={styles.title}>Consent Manager</h1>
//                     <p className={styles.subtitle}>
//                         Review and manage principal investigator consent submissions
//                     </p>
//                 </div>
//             </div>

//             <div className={styles.searchWrapper}>
//                 <div className={styles.searchContainer}>
//                     <Search className={styles.searchIcon} />
//                     <input
//                         type="text"
//                         placeholder="Search by PI name, study number, site code, or site name..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         className={styles.searchInput}
//                     />
//                 </div>
//             </div>

//             <div className={styles.submissionsContainer}>
//                 {filteredSubmissions.length === 0 ? (
//                     <div className={styles.emptyState}>
//                         <FileText className={styles.emptyIcon} size={48} />
//                         <p>No submissions found</p>
//                     </div>
//                 ) : (
//                     filteredSubmissions.map((submission) => (
//                         <div key={submission.id} className={styles.card}>
//                             <div className={styles.cardHeader}>
//                                 <div className={styles.cardHeaderLeft}>
//                                     <h2 className={styles.piName}>{submission.piName}</h2>
//                                     <span className={`${styles.statusBadge} ${getStatusBadgeClass(submission.status)}`}>
//                                         {submission.status}
//                                     </span>
//                                 </div>

//                                 <div className={styles.cardHeaderRight}>
//                                     <button
//                                         onClick={() => handleDownloadConsentAgreement(submission.id)}
//                                         className={styles.downloadAgreementButton}
//                                         disabled={downloadingId === submission.id}
//                                         title="Download Consent Agreement"
//                                     >
//                                         <Download className={styles.iconSmall} />
//                                         <span>{downloadingId === submission.id ? 'Downloading...' : 'Consent Agreement'}</span>
//                                     </button>

//                                     {userRole !== 'PI' && submission.status === 'PENDING' && (
//                                         <div className={styles.actionButtons}>
//                                             <button
//                                                 onClick={() => handleRejectClick(submission.id)}
//                                                 className={styles.rejectButton}
//                                                 disabled={isSubmitting}
//                                             >
//                                                 Reject
//                                             </button>
//                                             <button
//                                                 onClick={() => handleApprove(submission.id)}
//                                                 className={styles.approveButton}
//                                                 disabled={isSubmitting}
//                                             >
//                                                 {isSubmitting ? 'Processing...' : 'Approve'}
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className={styles.cardDetails}>
//                                 <div className={styles.detailItem}>
//                                     <span className={styles.detailLabel}>Study Details</span>
//                                     <span className={styles.detailValue}>{submission.protocolNumber} <br />{submission.studyName} </span>
//                                 </div>

//                                 <div className={styles.detailItem}>
//                                     <span className={styles.detailLabel}>Site Details</span>
//                                     <span className={styles.detailValue}>
//                                         {submission.siteDetails.code}
//                                         <br />
//                                         {submission.siteDetails.name}
//                                     </span>
//                                 </div>

//                                 <div className={styles.detailItem}>
//                                     <span className={styles.detailLabel}>Max. Subjects</span>
//                                     <span className={styles.detailValue}>{submission.maxSubjects}</span>
//                                 </div>

//                                 <div className={styles.detailItem}>
//                                     <span className={styles.detailLabel}>Submitted on</span>
//                                     <span className={styles.detailValue}>{formatDate(submission.submittedOn)}</span>
//                                 </div>
//                             </div>

//                             {submission.status === 'REJECTED' && submission.reason && (
//                                 <div className={styles.rejectionReason}>
//                                     <span className={styles.detailLabel}>Rejection Reason:</span>
//                                     <span className={styles.rejectionText}>{submission.reason}</span>
//                                 </div>
//                             )}

//                             {submission.documents && submission.documents.length > 0 ? (
//                                 <div className={styles.documentsSection}>
//                                     <h3 className={styles.sectionTitle}>Submitted Documents ({submission.documents.length})</h3>
//                                     <div className={styles.documentsList}>
//                                         {submission.documents.map((doc, index) => (
//                                             <div key={index} className={styles.documentItem}>
//                                                 <FileText className={styles.documentIcon} />
//                                                 <span className={styles.documentName}>
//                                                     {doc.name}
//                                                 </span>
//                                                 <div className={styles.documentActions}>
//                                                     <button
//                                                         className={styles.iconButton}
//                                                         title="Preview"
//                                                         onClick={() => handleViewDocument(doc.filename, doc.name)}
//                                                     >
//                                                         <Eye className={styles.iconSmall} />
//                                                     </button>
//                                                     <button
//                                                         className={styles.iconButton}
//                                                         title="Download"
//                                                         onClick={() => handleDownloadDocument(doc.filename, doc.name)}
//                                                     >
//                                                         <Download className={styles.iconSmall} />
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             ) : (
//                                 <div className={styles.noDocuments}>
//                                     <p>No documents submitted</p>
//                                 </div>
//                             )}
//                         </div>
//                     ))
//                 )}
//             </div>

//             <ConfirmationModal
//                 show={showRejectModal}
//                 onConfirm={handleRejectConfirm}
//                 onCancel={handleRejectCancel}
//                 title="Confirm Rejection"
//                 message="Are you sure you want to reject this consent? You will be asked to provide a reason."
//                 confirmText="Continue"
//                 cancelText="Cancel"
//                 type="warning"
//             />

//             {showReasonModal && (
//                 <div className={styles.modalOverlay} onClick={handleReasonCancel}>
//                     <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//                         <div className={styles.modalHeader}>
//                             <h3 className={styles.modalTitle}>Reason for Rejection</h3>
//                             <button
//                                 className={styles.modalCloseButton}
//                                 onClick={handleReasonCancel}
//                                 aria-label="Close"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>
//                         <div className={styles.modalBody}>
//                             <textarea
//                                 value={rejectReason}
//                                 onChange={(e) => setRejectReason(e.target.value)}
//                                 placeholder="Enter reason for rejection..."
//                                 className={styles.rejectTextarea}
//                                 rows={5}
//                                 autoFocus
//                             />
//                         </div>
//                         <div className={styles.modalFooter}>
//                             <button
//                                 onClick={handleReasonCancel}
//                                 className={styles.cancelButton}
//                                 disabled={isSubmitting}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleReasonSubmit}
//                                 className={styles.submitButton}
//                                 disabled={isSubmitting || !rejectReason.trim()}
//                             >
//                                 {isSubmitting ? 'Submitting...' : 'Submit'}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showPreviewModal && (
//                 <div className={styles.modalOverlay} onClick={handleClosePreview}>
//                     <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//                         <div className={styles.modalHeader}>
//                             <h3 className={styles.modalTitle}>
//                                 {previewFile?.name || 'Document Preview'}
//                             </h3>
//                             <button
//                                 className={styles.modalCloseButton}
//                                 onClick={handleClosePreview}
//                                 aria-label="Close"
//                             >
//                                 <X size={24} />
//                             </button>
//                         </div>

//                         <div className={styles.modalBody}>
//                             {previewLoading && (
//                                 <div className={styles.previewLoading}>
//                                     <Loader className={`${styles.loadingIcon} ${styles.spinning}`} />
//                                     <p>Loading preview...</p>
//                                 </div>
//                             )}

//                             {previewError && (
//                                 <div className={styles.previewError}>
//                                     <AlertCircle className={styles.errorIcon} />
//                                     <p>{previewError}</p>
//                                 </div>
//                             )}
//                             {previewFile && !previewLoading && !previewError && (
//                                 <div className={styles.previewContainer}>
//                                     {previewFile.url ||
//                                         previewFile.name.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ? (
//                                         <img
//                                             src={previewFile.url}
//                                             alt={previewFile.name}
//                                             className={styles.previewImage}
//                                         />
//                                     ) : previewFile.type === 'pdf' || previewFile.name.endsWith('.pdf') ? (
//                                         <iframe
//                                             src={previewFile.url}
//                                             className={styles.previewIframe}
//                                             title={previewFile.name}
//                                         />
//                                     ) : (
//                                         <div className={styles.previewUnsupported}>
//                                             <FileText size={48} />
//                                             <p>Preview not available for this file type</p>
//                                             <button
//                                                 className={styles.downloadButton}
//                                                 onClick={() => handleDownloadDocument(previewFile.filename, previewFile.name)}
//                                             >
//                                                 Download File
//                                             </button>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ConsentManager;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, FileText, Eye, Download, Loader, AlertCircle, X } from 'lucide-react';
import styles from './ConsentManager.module.css';
import { getConsents, getConsentsFiles, updateConsent, getConsentsDownload } from '../../Config/api';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import LoadingContainer from '../../components/Common/LoadingContainer';

const ConsentManager = ({ userRole = 'CRO', currentPIName = 'Mahesh' }) => {
    const navigate = useNavigate();
    
    const [searchQuery, setSearchQuery] = useState('');
    const [submissions, setSubmissions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userId, setUserId] = useState(null);

    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [previewError, setPreviewError] = useState(null);

    const [showRejectModal, setShowRejectModal] = useState(false);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [selectedConsentId, setSelectedConsentId] = useState(null);
    const [rejectReason, setRejectReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [downloadingId, setDownloadingId] = useState(null);

    const [modal, setModal] = useState({
        show: false,
        title: '',
        message: '',
        type: 'info',
        confirmText: 'OK',
        cancelText: null,
        onConfirm: null,
        onCancel: null
    });

    const showModal = (config) => {
        setModal({
            show: true,
            title: config.title || '',
            message: config.message || '',
            type: config.type || 'info',
            confirmText: config.confirmText || 'OK',
            cancelText: config.cancelText || null,
            onConfirm: config.onConfirm || closeModal,
            onCancel: config.onCancel || closeModal
        });
    };

    const closeModal = () => {
        setModal({
            show: false,
            title: '',
            message: '',
            type: 'info',
            confirmText: 'OK',
            cancelText: null,
            onConfirm: null,
            onCancel: null
        });
    };

    useEffect(() => {
        fetchSubmissions();
    }, []);

    const fetchSubmissions = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const userDetails = JSON.parse(localStorage.getItem('user')) || {};
            // Handle role as object or string
            let role = userDetails.role || userRole;
            if (typeof role === 'object' && role !== null) {
                role = role.roleName || role.name || 'CRO';
            }
            const currentUserId = userDetails.userId;
            const email = userDetails.email;

            console.log('User Details from localStorage:', userDetails);
            console.log('Role being sent:', role);
            console.log('User ID being sent:', currentUserId);
            console.log('Email being sent:', email);

            setUserId(currentUserId);

            const requestData = {
                userId: currentUserId,
                role: role,
                email: email
            };

            console.log('Request Data:', requestData);

            const response = await getConsents(requestData);

            console.log('API Response:', response);

            let consentsList = [];

            if (Array.isArray(response.data)) {
                consentsList = response.data;
            } else if (response.data && typeof response.data === 'object') {
                consentsList = [response.data];
            } else if (Array.isArray(response)) {
                consentsList = response;
            } else {
                consentsList = [];
            }

            const mappedSubmissions = consentsList.map(consent => {
                const documents = [];

                if (consent.uploaded_docs) {
                    Object.entries(consent.uploaded_docs).forEach(([docType, docInfo]) => {
                        if (docInfo && docInfo.filename && docInfo.originalName) {
                            documents.push({
                                name: docInfo.originalName,
                                filename: docInfo.filename,
                                type: docType
                            });
                        }
                    });
                }

                let status = 'PENDING';
                const consentStatus = consent.consent_status?.toLowerCase();

                if (consentStatus === 'a' || consentStatus === 'approved') {
                    status = 'APPROVED';
                } else if (consentStatus === 'r' || consentStatus === 'rejected') {
                    status = 'REJECTED';
                } else if (consentStatus === 'p' || consentStatus === 'pending') {
                    status = 'PENDING';
                }

                const mappedConsent = {
                    id: consent.id,
                    piName: consent.full_name || 'N/A',
                    protocolNumber: consent.study_number || 'N/A',
                    studyName: consent.study_title || 'N/A',
                    siteDetails: {
                        code: consent.site_code || 'N/A',
                        name: consent.site_name || 'N/A'
                    },
                    maxSubjects: consent.max_subjects || 0,
                    submittedOn: consent.created_at || new Date().toISOString(),
                    status: status,
                    documents: documents,
                    reason: consent.reason || null
                };

                return mappedConsent;
            });

            setSubmissions(mappedSubmissions);

        } catch (error) {
            console.error('Fetch consents error:', error);
            const errorMessage = error.response?.data?.message 
                || error.response?.data?.error 
                || error.message 
                || 'Failed to load consents. Please try again.';
            
            // Check if error indicates no records found (not a real error)
            const noRecordsMessages = [
                'invalid email',
                'email does not exist',
                'no records',
                'not found',
                'no consent'
            ];
            
            const isNoRecordsError = noRecordsMessages.some(msg => 
                errorMessage.toLowerCase().includes(msg)
            );
            
            if (isNoRecordsError) {
                // Treat as empty data, not an error
                setSubmissions([]);
                setError(null);
            } else {
                setError(errorMessage);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const getFilteredSubmissions = () => {
        let filtered = [...submissions];

        if (userRole === 'PI') {
            const userDetails = JSON.parse(localStorage.getItem('user')) || {};
            const currentUserName = userDetails.fullName || currentPIName;

            filtered = submissions.filter(sub => {
                return sub.piName === currentUserName;
            });
        }

        if (searchQuery) {
            filtered = filtered.filter(sub =>
                sub.piName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                sub.protocolNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
                sub.siteDetails.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
                sub.siteDetails.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        return filtered;
    };

    const handleDownloadConsentAgreement = async (consentId) => {
        try {
            setDownloadingId(consentId);

            const payload = {
                consent_id: consentId,
                type: 'pdf'
            };

            const response = await getConsentsDownload(payload);

            console.log('Full response object:', response);
            console.log('Response headers:', response?.headers);
            
            // Debug: Log all available headers
            if (response?.headers) {
                console.log('Headers type:', typeof response.headers);
                console.log('All headers keys:', Object.keys(response.headers));
                for (const [key, value] of Object.entries(response.headers)) {
                    console.log(`Header [${key}]:`, value);
                }
            } else {
                console.log('No headers found in response');
                console.log('Response keys:', response ? Object.keys(response) : 'response is null/undefined');
            }

            let pdfData = null;

            if (response?.data) {
                pdfData = response.data;
            } else if (response) {
                pdfData = response;
            }

            if (pdfData) {
                // Get filename from Content-Disposition header
                let filename = `consent_agreement_${consentId}.pdf`;
                
                // Try different ways to access content-disposition header
                const contentDisposition = 
                    response?.headers?.['content-disposition'] || 
                    response?.headers?.['Content-Disposition'] ||
                    response?.headers?.get?.('content-disposition') ||
                    response?.headers?.get?.('Content-Disposition');
                
                console.log('Content-Disposition header:', contentDisposition);
                
                if (contentDisposition) {
                    // Try to extract filename from header
                    let filenameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;\n"']+)['"]?/i);
                    if (!filenameMatch) {
                        filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    }
                    if (filenameMatch && filenameMatch[1]) {
                        filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, '').trim());
                    }
                }

                console.log('Downloaded filename:', filename);

                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                showModal({
                    title: 'Error',
                    message: 'Failed to download consent agreement. No data received.',
                    type: 'error',
                    confirmText: 'OK'
                });
            }

        } catch (error) {
            console.error('Download error:', error);
            showModal({
                title: 'Error',
                message: error.response?.data?.message || 'Failed to download consent agreement. Please try again.',
                type: 'error',
                confirmText: 'OK'
            });
        } finally {
            setDownloadingId(null);
        }
    };

    const handleApprove = async (id) => {
        try {
            setIsSubmitting(true);

            const data = {
                consentId: id,
                status: 'a',
                reason: ''
            };

            const response = await updateConsent(data);

            if (response.success || response.data?.success || response.data?.message === 'Consent status updated' || response.message === 'Consent status updated') {
                showModal({
                    title: 'Success',
                    message: 'Consent approved successfully!',
                    type: 'success',
                    confirmText: 'OK',
                    onConfirm: async () => {
                        closeModal();
                        await fetchSubmissions();
                    }
                });
            } else {
                showModal({
                    title: 'Success',
                    message: 'Consent approved successfully!',
                    type: 'success',
                    confirmText: 'OK',
                    onConfirm: async () => {
                        closeModal();
                        await fetchSubmissions();
                    }
                });
            }

        } catch (error) {
            if (error.message === 'Consent status updated' || error.response?.data?.message === 'Consent status updated') {
                showModal({
                    title: 'Success',
                    message: 'Consent approved successfully!',
                    type: 'success',
                    confirmText: 'OK',
                    onConfirm: async () => {
                        closeModal();
                        await fetchSubmissions();
                    }
                });
            } else {
                showModal({
                    title: 'Error',
                    message: error.response?.data?.message || error.message || 'Failed to approve consent. Please try again.',
                    type: 'error',
                    confirmText: 'OK'
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleRejectClick = (id) => {
        setSelectedConsentId(id);
        setShowRejectModal(true);
    };

    const handleRejectConfirm = () => {
        setShowRejectModal(false);
        setShowReasonModal(true);
    };

    const handleRejectCancel = () => {
        setShowRejectModal(false);
        setSelectedConsentId(null);
    };

    const handleReasonSubmit = async () => {
        if (!rejectReason.trim()) {
            showModal({
                title: 'Validation Error',
                message: 'Please provide a reason for rejection',
                type: 'warning',
                confirmText: 'OK'
            });
            return;
        }

        try {
            setIsSubmitting(true);

            const data = {
                consentId: selectedConsentId,
                userId: userId,
                status: 'r',
                reason: rejectReason
            };

            const response = await updateConsent(data);

            if (response.success || response.data?.success || response.data?.message === 'Consent status updated' || response.message === 'Consent status updated') {
                showModal({
                    title: 'Success',
                    message: 'Consent rejected successfully!',
                    type: 'success',
                    confirmText: 'OK',
                    onConfirm: async () => {
                        closeModal();
                        setShowReasonModal(false);
                        setRejectReason('');
                        setSelectedConsentId(null);
                        await fetchSubmissions();
                    }
                });
            } else {
                showModal({
                    title: 'Success',
                    message: 'Consent rejected successfully!',
                    type: 'success',
                    confirmText: 'OK',
                    onConfirm: async () => {
                        closeModal();
                        setShowReasonModal(false);
                        setRejectReason('');
                        setSelectedConsentId(null);
                        await fetchSubmissions();
                    }
                });
            }

        } catch (error) {
            if (error.message === 'Consent status updated' || error.response?.data?.message === 'Consent status updated') {
                showModal({
                    title: 'Success',
                    message: 'Consent rejected successfully!',
                    type: 'success',
                    confirmText: 'OK',
                    onConfirm: async () => {
                        closeModal();
                        setShowReasonModal(false);
                        setRejectReason('');
                        setSelectedConsentId(null);
                        await fetchSubmissions();
                    }
                });
            } else {
                showModal({
                    title: 'Error',
                    message: error.response?.data?.message || error.message || 'Failed to reject consent. Please try again.',
                    type: 'error',
                    confirmText: 'OK'
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReasonCancel = () => {
        setShowReasonModal(false);
        setRejectReason('');
        setSelectedConsentId(null);
    };

    const handleResubmit = (consentId) => {
        navigate('/service-agreement', {
            state: {
                consentId: consentId,
                isResubmission: true
            }
        });
    };

    const handleViewDocument = async (filename, documentName) => {
        setShowPreviewModal(true);
        setPreviewLoading(true);
        setPreviewError(null);
        setPreviewFile(null);

        try {
            const response = await getConsentsFiles({ files: [filename] });

            let fileUrl = null;
            let fileType = null;

            if (response.files[0].filename) {
                fileUrl = response.files[0].url;
                fileType = response.files[0].type || response.files[0].mimeType;
            } else if (response.files[0]?.file) {
                fileUrl = response.files[0].file;
            } else if (response.url) {
                fileUrl = response.url;
            } else if (typeof response.data === 'string') {
                fileUrl = response.data;
            }

            if (fileUrl && fileUrl.startsWith('data:')) {
                setPreviewFile({
                    url: fileUrl,
                    name: documentName,
                    type: fileType || getFileTypeFromName(documentName)
                });
            } else if (fileUrl) {
                setPreviewFile({
                    url: fileUrl,
                    name: documentName,
                    type: fileType || getFileTypeFromName(documentName)
                });
            } else {
                throw new Error('File URL not found in response');
            }

        } catch (error) {
            setPreviewError(error.response?.data?.message || 'Failed to load file preview. Please try again.');
        } finally {
            setPreviewLoading(false);
        }
    };

    const getFileTypeFromName = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const pdfExtensions = ['pdf'];

        if (imageExtensions.includes(extension)) {
            return 'image';
        } else if (pdfExtensions.includes(extension)) {
            return 'pdf';
        }
        return 'unknown';
    };

    const handleClosePreview = () => {
        setShowPreviewModal(false);
        setPreviewFile(null);
        setPreviewError(null);
    };

    const handleDownloadDocument = (filename, documentName) => {
        if (filename) {
            const fileUrl = `${process.env.REACT_APP_API_BASE_URL || ''}/files/${filename}`;
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = documentName;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            showModal({
                title: 'Document Error',
                message: 'Document not available',
                type: 'error',
                confirmText: 'OK'
            });
        }
    };

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case 'PENDING':
                return styles.statusPending;
            case 'APPROVED':
                return styles.statusApproved;
            case 'REJECTED':
                return styles.statusRejected;
            default:
                return styles.statusPending;
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const { formatDateTimeWithSeconds } = require('../../utils/dateFormatter');
        return formatDateTimeWithSeconds(dateString);
    };

    if (isLoading) {
        return (
            <div className={styles.container}>
                <LoadingContainer message="Loading submissions..." />
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.errorWrapper}>
                    <AlertCircle className={styles.errorIconLarge} />
                    <h2 className={styles.errorTitle}>Failed to Load Submissions</h2>
                    <p className={styles.errorMessage}>{error}</p>
                    <button onClick={fetchSubmissions} className={styles.retryButton}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    const filteredSubmissions = getFilteredSubmissions();

    return (
        <div className={styles.container}>
            <ConfirmationModal
                show={modal.show}
                title={modal.title}
                message={modal.message}
                type={modal.type}
                confirmText={modal.confirmText}
                cancelText={modal.cancelText}
                onConfirm={modal.onConfirm}
                onCancel={modal.onCancel}
            />

            <div className={styles.header}>
                <div>
                    <h1 className={styles.title}>Consent Manager</h1>
                    <p className={styles.subtitle}>
                        Review and manage principal investigator consent submissions
                    </p>
                </div>
            </div>

            <div className={styles.searchWrapper}>
                <div className={styles.searchContainer}>
                    <Search className={styles.searchIcon} />
                    <input
                        type="text"
                        placeholder="Search by PI name, study number, site code, or site name..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>
            </div>

            <div className={styles.submissionsContainer}>
                {filteredSubmissions.length === 0 ? (
                    <div className={styles.emptyState}>
                        <FileText className={styles.emptyIcon} size={48} />
                        <p>No consent records recorded</p>
                    </div>
                ) : (
                    filteredSubmissions.map((submission) => (
                        <div key={submission.id} className={styles.card}>
                            <div className={styles.cardHeader}>
                                <div className={styles.cardHeaderLeft}>
                                    <h2 className={styles.piName}>{submission.piName}</h2>
                                    <span className={`${styles.statusBadge} ${getStatusBadgeClass(submission.status)}`}>
                                        {submission.status}
                                    </span>
                                </div>

                                <div className={styles.cardHeaderRight}>
                                    <button
                                        onClick={() => handleDownloadConsentAgreement(submission.id)}
                                        className={styles.downloadAgreementButton}
                                        disabled={downloadingId === submission.id}
                                        title="Download Consent Agreement"
                                    >
                                        <Download className={styles.iconSmall} />
                                        <span>{downloadingId === submission.id ? 'Downloading...' : 'Consent Agreement'}</span>
                                    </button>

                                    {/* Resubmit button for PI when consent is rejected */}
                                    {userRole === 'PI' && submission.status === 'REJECTED' && (
                                        <button
                                            onClick={() => handleResubmit(submission.id)}
                                            className={styles.resubmitButton}
                                            disabled={isSubmitting}
                                        >
                                            Resubmit
                                        </button>
                                    )}

                                    {/* Approve/Reject buttons - for CRO, Sponsor, and Admin roles (not PI) */}
                                    {userRole !== 'PI' && submission.status === 'PENDING' && (
                                        <div className={styles.actionButtons}>
                                            <button
                                                onClick={() => handleRejectClick(submission.id)}
                                                className={styles.rejectButton}
                                                disabled={isSubmitting}
                                            >
                                                Reject
                                            </button>
                                            <button
                                                onClick={() => handleApprove(submission.id)}
                                                className={styles.approveButton}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Processing...' : 'Approve'}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className={styles.cardDetails}>
                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}>Study Details</span>
                                    <span className={styles.detailValue}>{submission.protocolNumber} <br />{submission.studyName} </span>
                                </div>

                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}>Site Details</span>
                                    <span className={styles.detailValue}>
                                        {submission.siteDetails.code}
                                        <br />
                                        {submission.siteDetails.name}
                                    </span>
                                </div>

                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}>Max. Subjects</span>
                                    <span className={styles.detailValue}>{submission.maxSubjects}</span>
                                </div>

                                <div className={styles.detailItem}>
                                    <span className={styles.detailLabel}>Submitted on</span>
                                    <span className={styles.detailValue}>{formatDate(submission.submittedOn)}</span>
                                </div>
                            </div>

                            {submission.status === 'REJECTED' && submission.reason && (
                                <div className={styles.rejectionReason}>
                                    <span className={styles.detailLabel}>Rejection Reason:</span>
                                    <span className={styles.rejectionText}>{submission.reason}</span>
                                </div>
                            )}

                            {submission.documents && submission.documents.length > 0 ? (
                                <div className={styles.documentsSection}>
                                    <h3 className={styles.sectionTitle}>Submitted Documents ({submission.documents.length})</h3>
                                    <div className={styles.documentsList}>
                                        {submission.documents.map((doc, index) => (
                                            <div key={index} className={styles.documentItem}>
                                                <FileText className={styles.documentIcon} />
                                                <span className={styles.documentName}>
                                                    {doc.name}
                                                </span>
                                                <div className={styles.documentActions}>
                                                    <button
                                                        className={styles.iconButton}
                                                        title="Preview"
                                                        onClick={() => handleViewDocument(doc.filename, doc.name)}
                                                    >
                                                        <Eye className={styles.iconSmall} />
                                                    </button>
                                                    <button
                                                        className={styles.iconButton}
                                                        title="Download"
                                                        onClick={() => handleDownloadDocument(doc.filename, doc.name)}
                                                    >
                                                        <Download className={styles.iconSmall} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className={styles.noDocuments}>
                                    <p>No documents submitted</p>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>

            <ConfirmationModal
                show={showRejectModal}
                onConfirm={handleRejectConfirm}
                onCancel={handleRejectCancel}
                title="Confirm Rejection"
                message="Are you sure you want to reject this consent? You will be asked to provide a reason."
                confirmText="Continue"
                cancelText="Cancel"
                type="warning"
            />

            {showReasonModal && (
                <div className={styles.modalOverlay} onClick={handleReasonCancel}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3 className={styles.modalTitle}>Reason for Rejection</h3>
                            <button
                                className={styles.modalCloseButton}
                                onClick={handleReasonCancel}
                                aria-label="Close"
                            >
                                <X size={24} />
                            </button>
                        </div>
                        <div className={styles.modalBody}>
                            <textarea
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                                placeholder="Enter reason for rejection..."
                                className={styles.rejectTextarea}
                                rows={5}
                                autoFocus
                            />
                        </div>
                        <div className={styles.modalFooter}>
                            <button
                                onClick={handleReasonCancel}
                                className={styles.cancelButton}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleReasonSubmit}
                                className={styles.submitButton}
                                disabled={isSubmitting || !rejectReason.trim()}
                            >
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showPreviewModal && (
                <div className={styles.modalOverlay} onClick={handleClosePreview}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3 className={styles.modalTitle}>
                                {previewFile?.name || 'Document Preview'}
                            </h3>
                            <button
                                className={styles.modalCloseButton}
                                onClick={handleClosePreview}
                                aria-label="Close"
                            >
                                <X size={24} />
                            </button>
                        </div>

                        <div className={styles.modalBody}>
                            {previewLoading && (
                                <div className={styles.previewLoading}>
                                    <Loader className={`${styles.loadingIcon} ${styles.spinning}`} />
                                    <p>Loading preview...</p>
                                </div>
                            )}

                            {previewError && (
                                <div className={styles.previewError}>
                                    <AlertCircle className={styles.errorIcon} />
                                    <p>{previewError}</p>
                                </div>
                            )}
                            {previewFile && !previewLoading && !previewError && (
                                <div className={styles.previewContainer}>
                                    {previewFile.url ||
                                        previewFile.name.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ? (
                                        <img
                                            src={previewFile.url}
                                            alt={previewFile.name}
                                            className={styles.previewImage}
                                        />
                                    ) : previewFile.type === 'pdf' || previewFile.name.endsWith('.pdf') ? (
                                        <iframe
                                            src={previewFile.url}
                                            className={styles.previewIframe}
                                            title={previewFile.name}
                                        />
                                    ) : (
                                        <div className={styles.previewUnsupported}>
                                            <FileText size={48} />
                                            <p>Preview not available for this file type</p>
                                            <button
                                                className={styles.downloadButton}
                                                onClick={() => handleDownloadDocument(previewFile.filename, previewFile.name)}
                                            >
                                                Download File
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ConsentManager;